export const loginFr = {
  adminLogin: "Connexion Admin",
  teacherLogin: "Connexion Enseignant",
  parentLogin: "Connexion Parent",
  adminTitle: "Système Éducatif",
  adminSubtitle: "Connexion Administrateur",
  associationName: "Association Al-Falah",
  adminWarning: "Cette zone est réservée aux administrateurs uniquement. Veuillez vérifier votre identité avant de continuer.",
  adminWelcome: "Bienvenue sur la plateforme administrateurs - Gestion complète du système éducatif",
  adminPlatform: "Plateforme Administrateurs",
  adminDescription: "Gestion complète de tous les aspects du système éducatif et suivi des performances",
  adminServices: "Services disponibles pour les administrateurs:",
  adminService1: "Gestion des étudiants et enseignants",
  adminService2: "Gestion des notes et évaluations",
  adminService3: "Gestion de la communication et rapports",
  adminService4: "Paramètres système et statistiques",
  teacherTitle: "Système Éducatif", 
  teacherSubtitle: "Connexion Enseignant",
  teacherWelcome: "Bienvenue sur la plateforme enseignants - Gérez et suivez vos étudiants dans la mémorisation du Coran",
  teacherPlatform: "Plateforme Enseignants",
  teacherDescription: "Gérez et suivez vos étudiants dans la mémorisation du Coran et évaluez leurs performances",
  teacherServices: "Services disponibles pour les enseignants:",
  teacherService1: "Enregistrement du suivi de mémorisation",
  teacherService2: "Enregistrement des notes et évaluations",
  teacherService3: "Communication avec les parents",
  teacherService4: "Consultation des rapports et statistiques",
  parentTitle: "Système Éducatif",
  parentSubtitle: "Connexion Parent",
  parentWelcome: "Bienvenue sur la plateforme parents - Suivez les progrès de vos enfants dans la mémorisation du Coran",
  parentPlatform: "Plateforme Parents",
  parentDescription: "Suivez les progrès de vos enfants dans la mémorisation du Coran et leur performance académique",
  parentServices: "Services disponibles pour les parents:",
  parentService1: "Suivi des progrès de l'étudiant en mémorisation",
  parentService2: "Consultation des notes et évaluations",
  parentService3: "Communication avec les enseignants", 
  parentService4: "Réception des rapports mensuels",
  email: "Adresse e-mail",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  rememberMe: "Se souvenir de moi",
  forgotPassword: "Mot de passe oublié ?",
  login: "Se connecter",
  loading: "Connexion en cours...",
  noAccount: "Pas de compte ? Créer un nouveau compte",
  backHome: "Retour à la page d'accueil",
  adminRequest: "Demander des privilèges d'administration",
  enterUsername: "Entrez le nom d'utilisateur",
  enterPassword: "Entrez le mot de passe",
  fillAllFields: "Veuillez remplir tous les champs",
  loginError: "Erreur de connexion",
  connectionError: "Erreur de connexion au serveur",
  enterUsernamePassword: "Veuillez entrer le nom d'utilisateur et le mot de passe",
  serverError: "Une erreur s'est produite lors de la vérification des données",
  maintenanceTitle: "Site en construction",
  maintenanceMessage: "Nous travaillons actuellement sur le développement et l'amélioration du site. Il sera lancé bientôt, Insha'Allah",
  forStaffAndAdmins: "Pour le personnel et les administrateurs",
  forStaffAndAdminsOnly: "Pour le personnel et les administrateurs uniquement",
  resetSession: "Réinitialiser la session",
  noAccess: "Vous n'avez pas l'autorisation d'accéder à cette page. Type d'utilisateur",
  unknown: "Non spécifié",
  or: "ou",
  forgotPasswordDescription: "Entrez votre adresse e-mail, nom d'utilisateur ou numéro de téléphone pour renvoyer vos informations de connexion",
  optional: "optionnel",
  enterEmail: "Entrez l'adresse e-mail",
  enterPhone: "Entrez le numéro de téléphone",
  phone: "Numéro de téléphone",
  cancel: "Annuler",
  send: "Envoyer",
  forgotPasswordError: "Veuillez entrer au moins l'un des champs suivants : e-mail, nom d'utilisateur ou numéro de téléphone",
  forgotPasswordSuccess: "Les informations de connexion ont été envoyées à votre adresse e-mail"
};

